import {
  apiUrl,
  getList,
  getSingleRecord,
  saveRecord,
  deleteRecord,
  exportData,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { KeyPoolNotificationListItem } from '../types/api';

const baseUrl = apiUrl + '/keys/pools/notifications/';

export function getKeyPoolNotifications(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<KeyPoolNotificationListItem>> {
  return getList(`${baseUrl}search`, params);
}

export function getKeyPoolNotificationById(id: string): Promise<KeyPoolNotificationListItem> {
  return getSingleRecord(baseUrl, id);
}

export function saveKeyPoolNotification(
  model: Partial<KeyPoolNotificationListItem>
): Promise<{ id: string }> {
  return saveRecord(baseUrl, model);
}

export function deleteKeyPoolNotification(id: string): Promise<{ id: string }> {
  return deleteRecord(baseUrl, id);
}

export function exportKeyPoolNotificationData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/keys/pools/notifications/search`, 'sku', params);
}
